import { KeycloakService } from 'keycloak-angular'
import { environment } from '../../../environments/environment'

export function initializer(keycloak: KeycloakService) {
  return () => {
    return keycloak.init({
      config: environment.keycloak,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
      },
      enableBearerInterceptor: true,
    })
  }
}
